<template>
  <div name="page" class="h-screen overflow-y-hidden ">


    <div
      class="flex flex-auto flex-shrink-0 bg-gray-200 antialiased h-full text-slate-500"
      v-bind:class="[
          $route.meta.loginLayout || $route.meta.hideHeader ? 'ml-0' : 'mt-0',
        ]"
    >
      <sidebarview
        v-if="!$route.meta.loginLayout && !$route.meta.hideHeader && ($route.meta.showSide || $route.meta.showSide === undefined)"
        ref="sidebar"
        :parent="$route.meta.subnav"
      >
      </sidebarview>

      <div
        class="  w-full "
        v-bind:class="[
          $route.meta.loginLayout || $route.meta.hideHeader ? 'ml-0' : 'ml-6',
        ]"
      >
    <topbarview  v-if="!$route.meta.loginLayout && !$route.meta.hideHeader"></topbarview>

      <div
        class="w-full h-full min-h-screen overflow-y-auto  route-page"
 v-bind:class="[
          $route.meta.loginLayout || $route.meta.hideHeader ? 'rounded-none' : 'bg-white rounded-2xl ',
        ]"
      >
      
        <router-view v-if="isAvailable" ></router-view>
        </div>

      </div>
    </div>
  </div>
</template>



<script>
import sidebarview from "@/components/TheSidebar.vue";
import topbarview from "@/components/TheTopbar.vue";
import { mapGetters } from "vuex";

export default {
  name: "page",
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    displaName() {
      return this.currentUser.schoolName;
    },
  },
     watch: {
        $route(to, from) {
          // if(this.currentUser.isOnFree) {
          //  // this.isAvailable = this.hasFreeAccessTo(to)
          // }
        //   console.log(to)
        }
    },
  data: function () {
    return {
         isAvailable: true
    };
  },
  methods: {
    toggleNav: function () {
      var current = this.$refs.sidebar.style.display;
      if (current == "" || current == "none") {
        this.$refs.sidebar.style.display = "block";
      } else {
        this.$refs.sidebar.style.display = "none";
      }
    },
    setBackground() {
      // console.log(this.$hostname)
      let login = this.$route.meta.loginLayout ? "login" : "";
      let subdomain = this.$primaryStyle == false ? this.$hostname : "";
      return login + " " + subdomain;
    },
    setMainClass() {
      var hideHeader = this.$route.meta.hideHeader ? "hide_header" : "";
      var css =
        this.$route.meta.showSide == undefined ||
        this.$route.meta.showSide == false
          ? ""
          : "ml-56";
      css = css + hideHeader;
      return css;
    },
    // hasFreeAccessTo(route) {
    //   console.log(route)
    //   let freeList = ["/", "/news", "/planning", "/account", "/my-content", "/health", "health-content", "/health/education"]
    //   if (freeList.includes(route.path)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    checkCurrentLogin() {
      // console.log(this.currentUser);
      // console.log(this.currentUser.schoolID);
      // console.log(localStorage.getItem('user'));
      // if (localStorage.getItem('user')) {
      //   console.log(JSON.parse(localStorage.getItem('user')));
      // }
      // if (this.currentUser) {
      //   this.isLoggedIn = true
      // } else {
      //   this.isLoggedIn = false
      // }
      //if (!this.currentUser && this.$route.path !== '/') {
      //this.$router.push(this.$route.path)
      //}
    },

    updated() {
      console.log("REOUNT", this.$route);
    },
  },
  components: {
    sidebarview,
    topbarview
  },
};
</script>

<style>
/*****
Inner Head
******/


.inner {
  @apply bg-gray-200;
}

.inner-head {
  @apply w-full px-6 pt-4 pb-4 border-b h-20 border-transparent;
}

.inner-head .subnav {
  @apply text-sm pl-1 pt-3;
}

.inner-head-title {
  @apply text-2xl font-bold text-gray-900 mr-6 pt-2 pl-2 inline-block;
}

.inner-head-list-item {
  @apply inline-block mr-5 text-sm cursor-pointer;
}

.inner-head-list-item button {
  @apply opacity-50;
}

.inner-head-list-item > .active {
  @apply text-action-blue font-bold opacity-75;
}

/*****
SUB head
******/

.sub-head-title {
  @apply text-lg font-bold text-gray-900 mr-6 pt-2 pl-2 inline-block;
}

/*****
Filter
******/

.filter-bar {
  @apply bg-white h-16 py-3 pl-8 text-gray-500;
}

.filter-button {
  @apply text-sm font-bold pr-3 pl-0 text-gray-700;
}

.filter-button i {
  @apply p-2 rounded-lg mr-1;
}

.filter-bar-search {
  @apply w-80 h-10  bg-white  border rounded  px-2 mr-3;
}

.filter-bar-button {
  @apply h-10  bg-white  border rounded  px-4 ml-1 mr-3 text-gray-700 text-sm;
}

.filter-bar-button i {
  @apply pr-1 font-semibold text-xs;
}

.filter-item-button {
  @apply mb-2 font-bold py-2 px-3 rounded;
}

.filter-item-button.wide {
  @apply px-4;
}

.filter-item-button:hover {
  @apply text-action-blue bg-gray-400;
}
.filter-item-button-on {
  @apply bg-action-blue bg-opacity-75 text-white;
}

.filter-item-button-off {
  @apply bg-gray-100 text-gray-500;
}

.tbh-sort {
  @apply text-lg ml-2 cursor-pointer;
}

.tbh-sort:hover {
  opacity: 0.5;
}

.panel-header {
  @apply pb-4 text-sm text-gray-700 font-bold mx-4;
}

.top-bar {
  @apply w-full   bg-white  text-right pr-12 pt-3 pb-5 border-solid border-b border-gray-200;
}

.top-bar .breadcrumb {
  @apply w-1/2 pt-4 pl-8 text-base capitalize text-left text-gray-500;
}

.action-button {
  @apply h-10 text-sm px-4 text-white bg-action-blue !important rounded bg-opacity-75;
}
.action-button i {
  @apply text-xs pr-1 font-semibold;
}

.action-button.not-round {
  @apply rounded-sm;
}

.action-list-item {
  @apply w-12 h-12 shadow-sm rounded-full  text-action-blue opacity-75  text-center cursor-pointer mx-2 text-xl;
}

.pad-right {
  @apply pr-0 !important;
}

.close-icon {
  @apply align-middle ml-2 cursor-pointer text-black text-3xl;
}

.carret {
  @apply opacity-50 px-2;
}

.tooltip-info {
  @apply rounded bg-action-blue bg-opacity-75 text-white;
}

.tooltip-info .tooltip-arrow {
  @apply border-action-blue opacity-75;
}

.publish-button {
  @apply text-white bg-action-blue font-bold py-2  px-4 rounded bg-opacity-75;
}

/*****
HEADER SUBNAV
******/

.header-subnav-holder {
  @apply w-11/12 ml-8  h-12 mb-6  bg-white border-b border-gray-200 flex content-center;
}

.header-subnav {
  @apply mr-3 px-3 ml-1 border-b border-transparent font-semibold text-gray-700 text-sm;
}

.header-subnav:hover {
  opacity: 0.5;
}

.header-subnav:hover {
  @apply text-black;
}

.header-subnav.selected {
  @apply text-blue-500 font-bold border-b border-blue-500;
}

/*****
FORM
******/

.form-box {
  @apply mt-3 border-b pb-3;
}

.form-box.no-border {
  @apply border-0 !important;
}

.form-box-title {
  @apply flex-none w-32 mr-2 pb-2 font-medium;
}

.form-label {
  @apply block uppercase tracking-wide text-gray-400 text-xs font-bold mb-2;
}

.form-icon-button {
  @apply font-bold py-2 px-4 rounded text-xs;
}

.tag-example {
  @apply text-white font-semibold cursor-pointer rounded w-14 p-1 text-xs;
}

.tag-example:hover {
  opacity: 0.5;
}

input[type="text"],
input[type="password"],
textarea {
  @apply px-4 py-3 rounded  mt-2 border w-full;
}

.selection-button {
  @apply rounded p-2 px-6 cursor-pointer text-xs;
}

/*****
Side
******/

.sidebar-section-head {
  @apply mt-3 mb-4  pl-3 font-bold text-sm;
}

.side-list-item {
  @apply inline-block rounded py-2  px-3  w-full text-left text-gray-600 mb-1;
}

.sidebar .router-link-exact-active,
.sidebar .active {
  @apply bg-gray-300;
}

.sidebar .router-link-exact-active i {
  @apply text-gray-500  opacity-100;
}

/*****************************
 **** SPINNER
 ***************************/

.spin-holder {
  @apply mt-8;
}

.spinner {
  @apply text-action-blue opacity-75 text-6xl mt-4;
}

.spin-holder p {
  @apply text-action-blue opacity-75 p-4 font-bold;
}

/*****************************
 **** Uploading progress
 ***************************/

.progress-circle {
  max-width: 100px;
  max-height: 100px;
  width: 100%;
  transform: scaleX(-1) rotate(-55deg);
}

.progress-circle__percent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.progress-circle__container {
  display: inline-block;
  position: relative;
}

.progress-circle__path {
  transition: 0.5s ease-in-out all;
}

.container {
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

@media screen and (min-width: 500px) {
  .container {
    flex-direction: row;
  }

  .progress-circle__button {
    margin-top: 0;
  }
}

/*****************************
 **** Curriculum
 ***************************/

.unit-view-content-title {
  @apply text-2xl  m-5  mt-2  font-bold  text-gray-700  capitalize  inline-block;
}

.feeling-box {
  @apply h-32 w-32 transform rotate-45 rounded-3xl uppercase font-bold;
}

.colour-hack {
  @apply text-orange-800 text-yellow-600  text-teal-700;
}

</style>
